import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";

import BackIcon from "../../images/BackIcon";
import { linkFormat } from "../../utilities/linkFormat";
import ChevronIcon from "../../images/ChevronIcon";
import PlusIcon from "../../images/PlusIcon";

function MenuSection({ link, pageScrolled }) {
  const { sectionLabel } = link.modelLink;
  const [secondaryExpanded, setSecondaryExpanded] = useState(false);
  const [tertiaryExpanded, setTertiaryExpanded] = useState(false);

  const toggleSubMenu = (level, expanded) => {
    if (level === "secondary") {
      const expandedState =
        expanded !== undefined ? expanded : !secondaryExpanded;
      setSecondaryExpanded(expandedState);
    }
    if (level === "tertiary") {
      const expandedState =
        expanded !== undefined ? expanded : !tertiaryExpanded;
      setTertiaryExpanded(expandedState);
    }
  };

  const handleKeyPress = (e, level) => {
    const code = e.keyCode;
    // Down arrow press opens dropdown
    if (code === 40) {
      e.preventDefault();
      if (level === "secondary") {
        setSecondaryExpanded(true);
      }
      if (level === "tertiary") {
        setTertiaryExpanded(true);
      }
    }
    // Up arrow press closes dropdown
    if (code === 38) {
      e.preventDefault();
      if (level === "secondary") {
        setSecondaryExpanded(false);
      }
      if (level === "tertiary") {
        setTertiaryExpanded(false);
      }
    }
  };

  const resetDropdown = () => {
    setSecondaryExpanded(false);
    setTertiaryExpanded(false);
  };

  const MobileBackBtn = ({ tabIdx, level }) => {
    return (
      <li className="hds-copy phone:hidden">
        <button
          className="flex items-center mb-3 go-back"
          tabIndex={tabIdx}
          onClick={() => toggleSubMenu(level, false)}
        >
          <BackIcon
            css={`
              phone: hidden;
            `}
          />
          <span
            className={`ml-xs header-transition ${
              pageScrolled ? "text-black" : "text-white"
            }`}
          >
            Back
          </span>
        </button>
      </li>
    );
  };
  const sub_menu_plus_icon_style = "submenu-plus-icon";

  if (link.modelLink.menuContent.length > 0) {
    return (
      <OutsideClickHandler onOutsideClick={resetDropdown}>
        <li
          role="listitem"
          className="md:relative px-0 pb-5 md:px-2 md:pb-0 lg:px-10 header_menu_mobile"
        >
          <button
            data-dropdown-toggle="dropdownNavbar"
            aria-expanded={secondaryExpanded ? "true" : "false"}
            aria-controls="dropdown"
            className={`nav-link flex ${sub_menu_plus_icon_style} items-center w-full ${
              secondaryExpanded ? "active" : ""
            }`}
            onClick={() => toggleSubMenu("secondary")}
            onKeyDown={(e) => handleKeyPress(e, "secondary")}
          >
            <span className="mr-2 md:text-base">{sectionLabel}</span>
            <span className="chevron_icon">
              <ChevronIcon
                css="transform rotate-0 md:-rotate-90"
                color={pageScrolled ? "black" : "white"}
              />
            </span>
            <span className="plus_icon">
              <PlusIcon
                css="transform rotate-0 md:-rotate-90 "
                color={pageScrolled ? "black" : "white"}
              />
            </span>
          </button>
          {/* Secondary Menu */}
          <div
            id="dropdownNavbar"
            aria-hidden={secondaryExpanded ? "false" : "true"}
            aria-expanded={secondaryExpanded ? "true" : "false"}
            className={`dropdown md:absolute p-3 top-0 right-0 bottom-0 left-0 md:top-auto md:right-auto md:bottom-auto md:left-auto md:border md:border-gray-500 md:rounded-md z-10 ${
              !secondaryExpanded ? "transform md:hidden hidden" : ""
            } header-transition`}
          >
            <ul>
              {link.modelLink.menuContent.map((subLink) => {
                if (
                  subLink.modelLink !== undefined &&
                  subLink.modelLink.menuContent !== undefined
                ) {
                  const label = subLink.modelLink.sectionLabel;
                  const url = subLink.modelLink.sectionLink;
                  const childLinks = subLink.modelLink.menuContent;
                  const sub_menu_additional_style = "ternarysubmenu";
                  if (childLinks.length) {
                    return (
                      <li
                        role="none"
                        className="md:relative mb-2 header_menu_mobile"
                        key={subLink.id}
                      >
                        <button
                          data-dropdown-toggle="dropdownSubNavbar"
                          aria-expanded={tertiaryExpanded ? "true" : "false"}
                          aria-controls="sub-dropdown"
                          className={`nav-link flex ${sub_menu_plus_icon_style} items-center w-full ${
                            tertiaryExpanded ? "active" : ""
                          }`}
                          tabIndex={secondaryExpanded ? "0" : "-1"}
                          onClick={() => toggleSubMenu("tertiary")}
                          onKeyDown={(e) => handleKeyPress(e, "tertiary")}
                        >
                          <span className="mr-2">{label}</span>
                          {/* We are changing the arrow svg with plug svg and commenting for reference
                          <ChevronIcon
                            css="transform -rotate-90"
                            color={pageScrolled ? "black" : "white"}
                          />*/}

                          <PlusIcon
                            css="transform -rotate-90"
                            color={pageScrolled ? "black" : "white"}
                          />
                        </button>
                        {/* Tertiary Menu */}
                        <div
                          id="dropdownSubNavbar"
                          aria-hidden={tertiaryExpanded ? "false" : "true"}
                          aria-expanded={tertiaryExpanded ? "true" : "false"}
                          className={`sub-dropdown md:absolute top-0 right-0 bottom-0 left-0 md:top-3 md:right-auto md:bottom-auto md:left-full w-full p-3 md:border md:border-gray-500 md:rounded-md z-10 ${
                            !tertiaryExpanded
                              ? "transform md:hidden hidden"
                              : ""
                          } header-transition ${sub_menu_additional_style}`}
                        >
                          <ul>
                            {/*We have changed the navigation from slide to dropdown
                            <MobileBackBtn
                              tabIdx={
                                secondaryExpanded && tertiaryExpanded ? "0" : "-1"
                              }
                              level="tertiary"
                            />*/}
                            {childLinks.map((link, i) => {
                              const label = link.modelLink.sectionLabel;
                              const url = link.modelLink.sectionLink;
                              return (
                                <li role="none" className="mb-2" key={i}>
                                  <a
                                    aria-label={`click to vist ${label}`}
                                    href={linkFormat(url)}
                                    tabIndex={
                                      secondaryExpanded && tertiaryExpanded
                                        ? "0"
                                        : "-1"
                                    }
                                    className="nav-link"
                                  >
                                    {label}
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        {/* End Tertiary Menu */}
                      </li>
                    );
                  } else {
                    return (
                      <li
                        role="none"
                        className="relative mb-2"
                        key={subLink.id}
                      >
                        <a
                          aria-label={`click to vist ${label}`}
                          href={linkFormat(url)}
                          tabIndex={secondaryExpanded ? "0" : "-1"}
                          className="nav-link"
                          onFocus={() => toggleSubMenu("tertiary", false)}
                        >
                          {label}
                        </a>
                      </li>
                    );
                  }
                }
              })}
            </ul>
          </div>
          {/* End Secondary Menu */}
        </li>
      </OutsideClickHandler>
    );
  } else {
    return (
      <div>
        <li className="md:relative px-0 pb-5 md:px-2 md:pb-0 lg:px-10 header_menu_mobile">
          <a
            className="nav-link md:text-base"
            href={linkFormat(link.modelLink.sectionLink)}
          >
            {sectionLabel}
          </a>
        </li>
      </div>
    );
  }
}

export default MenuSection;
